// extracted by mini-css-extract-plugin
module.exports = {"scrollbars":"styles_scrollbars__LgWXD","bar":"styles_bar__r21XK","slideInSearchBar":"styles_slideInSearchBar__NLQQ_"};